var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-button",class:{ 'disabled': _vm.disabled },on:{"click":_vm.toggleShowColumnChooser}},[_c('img',{attrs:{"src":_vm.icon,"width":"25","height":"25","alt":""}}),_c('span',{staticClass:"title"},[_vm._v("Column Chooser")])])
}
var staticRenderFns = []

export { render, staticRenderFns }